
import Drag from './drag'
import mixin from '@/mixins/rightNav'
import {
  findTargetParents,
  addEventListener,
  removeEventListener,
} from '@/utils/queryEle'
export default {
  components: {
    'drag-component': Drag,
  },
  mixins: [mixin],
  data() {
    return {
      config: {
        // 初始位置信息
        top: '40vh',
        right: '0.1rem',
        width: '1rem', // 拖拽元素的宽度 记得带单位
        side: true, // 自动靠边
        zIndex: 93,
      },
      limit: 3, // 超过多少条数据展示更多
      visible: false, // 是否展示更多
      expandTimer: null // 用于存储定时器引用
    }
  },
  computed: {
    getBackItems() {
      const tempArr = this.visible
        ? this.backItems
        : this.backItems.length < this.limit
        ? this.backItems
        : [
            this.backItems[0],
            {
              id: 888,
              icon: 'doublue-more',
              name: 'modules.about.more', // 更多
            },
          ]
      return tempArr
    },
  },
  mounted() {
    addEventListener(document, 'click', this.clickNotParent)
  },
  destroyed() {
    removeEventListener(document, 'click', this.clickNotParent)
  },
  beforeDestroy() {
    // 组件卸载前清理定时器，防止内存泄漏和对已销毁实例的操作
    if (this.expandTimer) {
      clearTimeout(this.expandTimer)
      this.expandTimer = null
    }
  },
  methods: {
    // 如果入口小于3个，取消折叠功能默认展开
    isExpand() {
      return this.backItems?.length < 3
    },
    handleExpandClick() {
      // 清除可能存在的旧定时器，避免重复触发
      if (this.expandTimer) {
        clearTimeout(this.expandTimer)
      }
      this.expandTimer = setTimeout(() => {
        this.visible = true
        this.expandTimer = null // 执行后清除引用
      }, 100)
    },
    // 默认折叠，点击more展开内容，失焦或点击其他地方则收起
    clickNotParent(e) {
      const parentElm = document.querySelector('.backtop_div')
      const isParant = findTargetParents(e.target, parentElm)
      if (!isParant && !this.isExpand()) {
        this.visible = false
      }
    },
  },
}
